import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { TransportOrderView } from '../../../models/transport-order-view.model';
import { MailTransporterConfigurationService } from '../../../services/mails-transporter-configuration.service';
import { FaDirectiveEnum } from '../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-my-transport',
  templateUrl: './my-transport.component.html',
  styleUrls: ['./my-transport.component.scss'],
})
export class MyTransportComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly transporterMailService = inject(MailTransporterConfigurationService);
  private readonly translateService = inject(TranslateService);

  public transportOrder!: TransportOrderView;
  public savMail?: string;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public ngOnInit(): void {
    combineLatest([this.activatedRoute.data, this.transporterMailService.retrieveConfiguration()]).subscribe({
      next: (result): void => {
        this.transportOrder = result[0]['transportOrder'];
        if (
          !!(result[1] as any).mailConfig &&
          !!(result[1] as any).mailConfig.body &&
          (result[1] as any).mailConfig.body.afterSaleService?.active &&
          (result[1] as any).mailConfig.body.afterSaleService.value !== ''
        ) {
          this.savMail = (result[1] as any).mailConfig.body.afterSaleService.value;
        }
      },
    });
  }

  public callSAV(): void {
    const subject = this.translateService.instant('baryApp.myTransport.sav.subject', { transportOrderId: this.transportOrder.id });
    window!.top!.location.href = 'mailto:' + this.savMail + '?subject=' + subject;
  }

  public previousState(): void {
    window.history.back();
  }
}
